import { Injectable } from '@angular/core';
import { ApiService } from '../net/apiRoute';
import { _HttpClient } from '../net/http.client';

@Injectable({
  providedIn: 'root'
})
export class SysApiService {

  constructor(private http: _HttpClient) {

  }

  get windwosStatus(): FormWindowState {
    return window["cefservice"]?.GetWindwosStatus();
  }
  //是否客户端
  get isWebkitClient() {

    return window["cefservice"];

  }
  registerMoveApp() {
    var oBox = document.getElementById("systoolbar");
    oBox.onmousedown = function () {
      oBox.onmousemove = function (e) {
        if (e.buttons == 1) {
          console.log(e)
          window["cefservice"].SendCmd("MouseDownMove", e.x, e.y);
        } else {
          oBox.onmousemove = null;

        }
        return false
      };
    };
    document.onmouseup = function () {
      console.log(0);
      oBox.onmousemove = null;
    };
  }
  setWindowMaxOrNormal() {
    if (this.windwosStatus == FormWindowState.Maximized) {
      this.setWindowStatus(FormWindowState.Normal);
    } else {
      this.setWindowStatus(FormWindowState.Maximized);
    }

  }
  setWindowStatus(status: FormWindowState) {
    window["cefservice"].SendCmd("SetWindwosStatus", status);
  }

  exitApp() {
    window["cefservice"].SendCmd('ExitApp');
  }

  
}



export enum FormWindowState {
  //
  // 摘要:
  //     默认大小的窗口。
  Normal = 0,
  //
  // 摘要:
  //     最小化的窗口。
  Minimized = 1,
  //
  // 摘要:
  //     最大化的窗口。
  Maximized = 2
}